/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowUpBetweenLines: {
  name: 'arrow-up-between-lines';
  data: string;
} = {
  name: 'arrow-up-between-lines',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.354.646a.5.5 0 0 0-.708 0l-2 2a.5.5 0 1 0 .708.708L7.5 2.207V15a.5.5 0 0 0 1 0V2.207l1.146 1.147a.5.5 0 0 0 .708-.708l-2-2ZM4 .5a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-1 0V1A.5.5 0 0 1 4 .5Zm8 0a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-1 0V1a.5.5 0 0 1 .5-.5Z" fill="currentColor"/></svg>`,
};
